import { render, staticRenderFns } from "./DialogEditWechat.vue?vue&type=template&id=35793338&scoped=true"
import script from "./DialogEditWechat.vue?vue&type=script&lang=js"
export * from "./DialogEditWechat.vue?vue&type=script&lang=js"
import style0 from "./DialogEditWechat.vue?vue&type=style&index=0&id=35793338&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35793338",
  null
  
)

export default component.exports